var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './CalendarDate.module.scss';
import { isSaturday, isSunday, setDate } from 'date-fns';
var CalendarDate = function (_a) {
    var _b;
    var date = _a.date, focusDate = _a.focusDate, activeDates = _a.activeDates, activeCompareDates = _a.activeCompareDates, isDisabled = _a.isDisabled, compareOn = _a.compareOn, onSelect = _a.onSelect;
    var _c = useState([]), overlapingDates = _c[0], setOverlapingDates = _c[1];
    var value = date.value, current = date.current;
    var currentDate = setDate(focusDate, value);
    var isActive = activeDates.includes(value);
    var isActiveCompare = activeCompareDates.includes(value);
    var isOverlap = isActive && isActiveCompare;
    useEffect(function () {
        var overlap = activeDates.filter(function (d) { return activeCompareDates.includes(d); });
        setOverlapingDates(overlap);
    }, [activeDates, activeCompareDates]);
    var isFirst = function (dates) {
        var firstSelection = value === dates[0];
        return firstSelection || isSunday(currentDate);
    };
    var isLast = function (dates) {
        var lastSelection = value === dates[dates.length - 1];
        return lastSelection || isSaturday(currentDate);
    };
    var getOrderClasses = function (dates) {
        return "".concat(isFirst(dates) ? styles.First : '', " ").concat(isLast(dates) ? styles.Last : '');
    };
    var classes = "".concat(current ? "".concat(styles.Current, " selectable") : '', " ").concat(isActive ? styles.Active : '', " ").concat(getOrderClasses(activeDates));
    var compareClasses = "".concat(isActiveCompare && compareOn ? styles.ActiveCompare : '', " ").concat(getOrderClasses(activeCompareDates));
    var overlapClasses = "".concat(isOverlap && compareOn ? styles.Overlap : '', " ").concat(getOrderClasses(overlapingDates));
    var onDateSelect = function () {
        current && onSelect(value);
    };
    return (_jsx("li", __assign({ className: cx(styles.Date, classes, (_b = {}, _b[styles.Disabled] = isDisabled, _b)), onClick: onDateSelect, "data-testid": "calendar-day-".concat(value) }, { children: _jsx("span", __assign({ className: compareClasses }, { children: _jsx("span", __assign({ className: overlapClasses }, { children: value })) })) })));
};
CalendarDate.propTypes = {
    compareOn: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};
export { CalendarDate };
//# sourceMappingURL=CalendarDate.js.map